import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDataGlance from './baseGlances/baseDataGlance'



export default function TotalLabor(props) {

    const { t } = useTranslation();
    return (
        <>
            <BaseDataGlance cssContentClass='labor-glance-body'
                cssHeadingClass='labor-glance-heading'
                cssIconClass='icons8-construction-worker'
                Heading={t('Labor')}
                DataPoint1={props.DP1}
                DataPoint2={(Math.sign(props.DP2) > 0) ? "<i class='icons8-sort-up' aria-hidden='true' style='font-size: 26px; color: green; vertical-align: middle;'  />" + props.DP2 + '%'
                    : "<i class='icons8-sort-down' aria-hidden='true' style='font-size: 26px; color: red; vertical-align: middle;'  />" + props.DP2 + '%'}
                DataPoint3={props.DP3 + ' ' + t('Hours')}
                showForwardButton={true}
            ></BaseDataGlance>
        </>
    );
}